import { useEffect, useMemo, useState } from "react";
import API from "../../../../../services/api";

function useProvision() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [showForm, setShowForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const { data } = await API.get("/provision/my-products");

      setProducts(data.products || []);
    } catch (err) {
      console.error("Fetch Products Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const filteredProducts = useMemo(() => {
    return products.filter((item) => {
      const matchSearch =
        item.productName
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.brand
          ?.toLowerCase()
          .includes(search.toLowerCase());

      const matchCategory =
        category === "All" ||
        item.category === category;

      return matchSearch && matchCategory;
    });
  }, [products, search, category]);

  const openAddModal = () => {
    setSelectedProduct(null);
    setShowForm(true);
  };

  const openEditModal = (product) => {
    setSelectedProduct(product);

    setShowDetails(false);
    setShowDelete(false);

    setShowForm(true);
  };

  const openDetailsModal = (product) => {
    setSelectedProduct(product);

    setShowForm(false);
    setShowDelete(false);

    setShowDetails(true);
  };

  const openDeleteModal = (product) => {
    setSelectedProduct(product);

    setShowForm(false);
    setShowDetails(false);

    setShowDelete(true);
  };

  const closeModals = () => {
    setShowForm(false);
    setShowDetails(false);
    setShowDelete(false);
    setSelectedProduct(null);
  };

  const deleteProduct = async () => {
    if (!selectedProduct) return;

    try {
      setDeleteLoading(true);

      await API.delete(`/provision/${selectedProduct._id}`);

      await fetchProducts();

      closeModals();

    } catch (err) {
      console.error(err);
    } finally {
      setDeleteLoading(false);
    }
  };

  return {
    products: filteredProducts,

    loading,
    deleteLoading,

    fetchProducts,

    search,
    setSearch,

    category,
    setCategory,

    selectedProduct,

    showForm,
    showDetails,
    showDelete,

    openAddModal,
    openEditModal,
    openDetailsModal,
    openDeleteModal,

    closeModals,

    deleteProduct,
  };
}

export default useProvision;